import { Api, clearTokens, queryClient } from '@frontend/shared';
import { getFreshTokens } from '@frontend/shared/passenger-api';

import { constants } from '../../constants';

let _extranetApi: Api | null = null;

/**
 * Client HTTP de l'Extranet API v1.8.4.
 *
 * **Tokens** : `getFreshTokens` est celui de `libs/shared` (passenger-api). L'Extranet
 * API n'expose aucun endpoint de refresh, mais `passenger-api
 * /authentication/v1/token/refresh` accepte ses tokens (`type: 'Extranet'`,
 * session d'une heure) — vérifié sur dev. `VITE_PASSENGER_API` doit donc
 * pointer sur le même environnement que `VITE_EXTRANET_API`.
 *
 * **Erreurs d'auth** : le client partagé appelle `onInvalidToken` d'après
 * `data.errorMessage`, pas d'après le statut HTTP.
 * - `INVALID_TOKEN` (401) : session morte → purge, `AuthenticatedLayout`
 *   redirige vers `/login`.
 * - `INVALID_USER_TYPE` (403) : l'appelant n'a pas le domaine de la route
 *   (ex. `/v1/invoices` sans profil Facturation). Ce n'est **pas** un signal
 *   d'invalidité du token : on laisse l'UI dégrader (`TableErrorRow`, toast).
 */
export const getExtranetApi = (): Api => {
  if (!_extranetApi) {
    _extranetApi = new Api(constants.extranetApi || '', getFreshTokens, reason => {
      if (reason === 'INVALID_USER_TYPE') {
        if (constants.isLocal) console.debug('[extranet] INVALID_USER_TYPE ignoré (403 fonctionnel)');
        return;
      }
      clearTokens(queryClient);
    });
  }
  return _extranetApi;
};
